import api from './api';
import { posService } from './posService';

export interface Invoice {
  id: number;
  order_number: string;
  customer_id: number;
  customer_name: string;
  customer_phone: string;
  subtotal: number;
  tax_amount: number;
  discount_amount: number;
  total_amount: number;
  payment_status: string;
  order_status: string;
  created_at: string;
}

export const orderService = {
  // Tạo hóa đơn mới
  createInvoice: async (data: {
    customerId: string;
    items: any[];
    subtotal: number;
    discount: number;
    tax: number;
    totalAmount: number;
  }): Promise<Invoice> => {
    try {
      console.log('Creating invoice with customer ID:', data.customerId);

      // Chuẩn bị dữ liệu cho API POS - chỉ gửi customer_id
      const orderData = {
        customer_id: parseInt(data.customerId) || 0,
        items: data.items.map(item => {
          const orderItem = {
            medicine_id: item.productId,
            quantity: item.quantity,
            unit_price: item.price,
            discount_percent: item.discount_percent || 0,
            discount_amount: item.discount_amount || 0,
            total_price: (item.price * item.quantity) - (item.discount_amount || 0),
            notes: item.notes || ''
          };
          console.log('Order item:', orderItem);
          return orderItem;
        }),
        subtotal: data.subtotal,
        tax_amount: data.tax,
        discount_amount: data.discount,
        total_amount: data.totalAmount,
        payment_method: 'cash',
        notes: ''
      };

      console.log('Order data to send:', orderData);
      console.log('Customer ID type:', typeof orderData.customer_id, 'Value:', orderData.customer_id);

      const response = await posService.createOrder(orderData);
      
      console.log('POS API response:', response);
      
      return {
        id: response.data.id,
        order_number: response.data.order_number,
        customer_id: parseInt(data.customerId) || 0,
        customer_name: 'Khách hàng', // Sẽ được lấy từ database
        customer_phone: '', // Sẽ được lấy từ database
        subtotal: data.subtotal,
        tax_amount: data.tax,
        discount_amount: data.discount,
        total_amount: data.totalAmount,
        payment_status: 'pending',
        order_status: 'completed',
        created_at: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error creating invoice:', error);
      console.error('Error details:', {
        message: (error as any).message,
        response: (error as any).response?.data,
        status: (error as any).response?.status
      });
      throw error;
    }
  },

  // Lấy chi tiết hóa đơn
  getInvoiceDetail: async (invoiceId: number): Promise<any> => {
    try {
      const response = await posService.getOrderDetail(invoiceId);
      return response;
    } catch (error) {
      console.error('Error getting invoice detail:', error);
      throw error;
    }
  },

  // Cập nhật trạng thái hóa đơn
  updateInvoiceStatus: async (invoiceId: number, status: string): Promise<void> => {
    try {
      await posService.updateOrder(invoiceId, { order_status: status });
    } catch (error) {
      console.error('Error updating invoice status:', error);
      throw error;
    }
  }
};